import { useEffect, useContext } from 'react'
import { useQuery } from 'react-query';
import * as Api from '../../api/Api';
import { useGetToken } from '../../Hooks/CustomHooks'
import { ErrorConnection } from "../../Components/Error/Error";
import { FeedbackContext } from "../Context/FeedbackContext";
import NotificationPanel from "./NotificationPanel";
import { useHistory } from 'react-router-dom';
import Tooltip from '../../Components/Message/Tooltip';

export default function NotificationManager({ user, setTotalNotificaciones, setIsLoading }) {

    let token = useGetToken();
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    const history = useHistory();

    let notificacionActions = [
        {
            "notificacionId": '1',
            "callback": (contrato) => {
                window.sessionStorage.setItem("ContratoPorNotificacionID", contrato.value1);
                let unidEconmId = contrato.value2.toUpperCase().includes(' AAQ') ? '2' :
                    contrato.value2.toUpperCase().includes(' ASA') ? '3' :
                        contrato.value2.toUpperCase().includes(' ACH') ? '6' : '3'

                window.sessionStorage.setItem("ContratoPorNotificacionUE", unidEconmId);
                return history.push("/Locatario/Index")
            }
        },
        {
            "notificacionId": '2',
            "callback": (contrato) => {
                let unidEconmId = contrato.value2.toUpperCase().includes(' AAQ') ? '2' :
                    contrato.value2.toUpperCase().includes(' ASA') ? '3' :
                        contrato.value2.toUpperCase().includes(' ACH') ? '6' : '3'

                window.sessionStorage.setItem("ContratoPorNotificacionUE", unidEconmId);
                return history.push("/Mapas/ModificarMapas")
            }
        },
        {
            "notificacionId": '3',
            "callback": () => { console.log('Falta actualizar datos de parkare y check retail') }
        }
    ];

    let { data, isLoading, isError, error, isFetching } = useQuery(['GetNotification', token],
        async () => await Api.GetNotifications(token),
        {
            enabled: true,
            refetchInterval: 7200000,
            refetchIntervalInBackground: true
        });

    useEffect(() => {
        if (data) {
            if (!data.success)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            else {
                let totalNotificaciones = 0;

                data.data.forEach((tipoNotificacion, index) => {
                    if (tipoNotificacion.perfiles.includes(parseInt(user.role)))
                        totalNotificaciones += tipoNotificacion.notificaciones.length;
                })
                setTotalNotificaciones(totalNotificaciones);
                setIsLoading(false);
            }
        }
    }, [data]);

    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <div className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px' data-kt-menu='true'>
                <div className='d-flex flex-column bgi-no-repeat rounded-top' >
                    <h3 className='fw-boldest px-9 mt-5 mb-1 fs-2'>Notificaciones</h3>

                    {data &&
                        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
                            {
                                data.data.map((element, index) => {
                                    let classLi = index == 0 ? 'nav-link opacity-100 opacity-state-100 pb-2 active' : 'nav-link opacity-50 opacity-state-100 pb-2';

                                    if (element.perfiles.includes(parseInt(user.role)))
                                        return (
                                            <li key={index} className='nav-item'>
                                                <a className={classLi} data-bs-toggle='tab' href={'#kt_topbar_notifications_' + element.id}>
                                                    {element.label}
                                                    <span className="badge badge-square badge-light badge-sm ms-3">{element.notificaciones.length}</span>
                                                    <div className='ms-2 tool-noti badge badge-square badge-light'><Tooltip message={element.descripcion}></Tooltip></div>
                                                </a>
                                            </li>
                                        )
                                    else return (null)
                                }
                                )
                            }
                        </ul>
                    }
                </div>

                {data &&
                    <div className='tab-content'>
                        {data.data.map((element, index) => {
                            if (element.perfiles.includes(parseInt(user.role)))
                                return (
                                    <NotificationPanel
                                        key={'panel' + index}
                                        index={index}
                                        dataPanel={element}
                                        callback={notificacionActions.find((notificacion) => notificacion.notificacionId == element.id)?.callback}>
                                    </NotificationPanel>
                                )
                            else return (null)

                        })}
                    </div>
                }
            </div>
        </>
    )
}